import { createAction, props } from "@ngrx/store";
import { ProductResponseDto } from "src/app/quote/term-life-insurance/services/backend/response/product-response.dto";
import {
  TermLifeInsuranceProductConfigurationResponseDto,
  TermLifeInsuranceQuoteResponseDto,
} from "src/app/quote/term-life-insurance/services/backend/response/term-life-insurance-quote-response.dto";
import { ExceptionResponseDto } from "src/app/shared/services/backend/shared/exceptions/exception-response.dto";
import { NavigationParameters } from "../../shared/navigation-parameters";
import { DataAnalyticsCampaign, QuoteFeatureState } from "./quote.state";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Business Actions
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const getTermLifeInsuranceQuote = createAction(
  "[Quote] [TermLifeInsurance] [Business] Get Quote",
  props<GetTermLifeInsuranceQuoteParameters>(),
);

export const getProductConfiguration = createAction(
  "[Quote] [TermLifeInsurance] [Business] Get Product Configuration",
);

export const submitQuote = createAction(
  "[Quote] [TermLifeInsurance] [Business] Submit Quote",
  props<SubmitParameters>(),
);

export const lockQuote = createAction(
  "[Quote] [TermLifeInsurance] [Business] Lock Quote",
  props<LockQuoteParameters>(),
);

export const getProduct = createAction(
  "[Quote] [TermLifeInsurance] [Business] Get Product",
  props<GetProductParameters>(),
);

export const storeQueryStringParameters = createAction(
  "[Quote] [TermLifeInsurance] [Business] Store Query String Parameters",
  props<QueryStringParameters>(),
);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Chain Reaction Action
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const getProductStart = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Product (start)",
  props<GetProductParameters>(),
);

export const getProductSuccess = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Product (success)",
  props<ProductResponseDto>(),
);

export const getProductFail = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Product (fail)",
  props<ExceptionResponseDto>(),
);

// GET (Quote)
export const getQuoteStart = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Quote (start)",
  props<GetTermLifeInsuranceQuoteParameters>(),
);

export const getQuoteSuccess = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Quote (success)",
  props<TermLifeInsuranceQuoteResponseDto>(),
);

export const getQuoteFail = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Quote (fail)",
  props<ExceptionResponseDto>(),
);

export const getQuoteCancel = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Quote (cancel)",
);

// CREATE
export const createQuoteStart = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Create Quote (start)",
  props<NavigationParameters>(),
);

export const createQuoteSuccess = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Create] Quote (success)",
  props<TermLifeInsuranceQuoteResponseDto & NavigationParameters>(),
);

export const createQuoteFail = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Create Quote (fail)",
  props<ExceptionResponseDto>(),
);

// UPDATE (Quote)
export const updateQuoteStart = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Update Quote (start)",
  props<UpdateTermLifeInsuranceQuoteParameters & NavigationParameters>(),
);

export const updateQuoteSuccess = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Update Quote (success)",
  props<TermLifeInsuranceQuoteResponseDto & NavigationParameters>(),
);

export const updateQuoteFail = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Update Quote (fail)",
  props<ExceptionResponseDto>(),
);

// GET (Product Configuration)
export const getProductConfigurationStart = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Product Configuration (start)",
);

export const getProductConfigurationSuccess = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Product Configuration (success)",
  props<TermLifeInsuranceProductConfigurationResponseDto>(),
);

export const getProductConfigurationFail = createAction(
  "[Quote] [TermLifeInsurance] [Backend] Get Product Configuration (fail)",
  props<ExceptionResponseDto>(),
);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Models
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface SubmitParameters extends NavigationParameters {
  state: QuoteFeatureState;
}

export interface UpdateQuoteParameters {
  quoteId: string;
}

export interface LockQuoteParameters {
  applicationId: string;
}

export type GetQuoteParameters = UpdateQuoteParameters;

export interface QueryStringParameters {
  dataAnalyticsCampaign: DataAnalyticsCampaign | undefined;
  attributionCode: string | undefined;
}

export interface GetProductParameters {
  quoteId: string;
}

export type UpdateTermLifeInsuranceQuoteParameters = UpdateQuoteParameters;

export type GetTermLifeInsuranceQuoteParameters = GetQuoteParameters;
